import React, { useEffect, useState } from 'react';
import styled, { css, keyframes } from 'styled-components';

const fadeOut = keyframes`
  to { opacity: 0; visibility: hidden; }
`;

const riseIn = keyframes`
  from { opacity: 0; transform: translateY(16px); }
  to { opacity: 1; transform: translateY(0); }
`;

const Screen = styled.div`
  position: fixed;
  inset: 0;
  z-index: 9999;
  background: var(--bg, #ece9e1);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 2.2rem;
  ${(p) =>
    p.$done &&
    css`
      animation: ${fadeOut} 0.5s ease forwards;
    `}
`;

const Wordmark = styled.div`
  font-family: var(--font-display, sans-serif);
  font-weight: 800;
  font-size: clamp(1.8rem, 5vw, 3rem);
  letter-spacing: -0.02em;
  color: var(--ink, #efeae3);
  animation: ${riseIn} 0.7s cubic-bezier(0.22, 1, 0.36, 1) both;

  span {
    color: var(--copper, #e08d3c);
  }
`;

const Track = styled.div`
  width: min(260px, 60vw);
  height: 2px;
  background: rgba(34, 31, 26, 0.12);
  border-radius: 2px;
  overflow: hidden;
  animation: ${riseIn} 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.15s both;
`;

const Bar = styled.div`
  height: 100%;
  width: ${(p) => p.$progress}%;
  background: linear-gradient(90deg, #f2b05e, #e08d3c);
  transition: width 0.18s ease-out;
`;

const Status = styled.p`
  font-family: var(--font-mono, monospace);
  font-size: 0.68rem;
  letter-spacing: 0.26em;
  text-transform: uppercase;
  color: var(--ink-faint, #6e6962);
  animation: ${riseIn} 0.7s cubic-bezier(0.22, 1, 0.36, 1) 0.25s both;
  font-variant-numeric: tabular-nums;
`;

export default function Loading({ onLoadingComplete }) {
  const [progress, setProgress] = useState(0);
  const [done, setDone] = useState(false);

  useEffect(() => {
    const id = setInterval(() => {
      setProgress((p) => {
        const next = p + Math.random() * 22 + 8;
        if (next >= 100) {
          clearInterval(id);
          setDone(true);
          setTimeout(() => onLoadingComplete && onLoadingComplete(), 520);
          return 100;
        }
        return next;
      });
    }, 130);
    return () => clearInterval(id);
  }, [onLoadingComplete]);

  return (
    <Screen $done={done} role="status" aria-label="Loading IEMENTech 2027">
      <Wordmark>
        IEMENTech <span>'27</span>
      </Wordmark>
      <Track>
        <Bar $progress={progress} />
      </Track>
      <Status>Initializing · {Math.round(progress)}%</Status>
    </Screen>
  );
}
